
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deploy",
      function () {
        return require("private-next-pages/deploy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deploy"])
      });
    }
  